import { mapState, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState('user', ['user']),

    stateName: {
      get () {
        return this.user.name
      },

      set (value) {
        this.setProperty({ property: 'name', value })
      }
    },

    stateEmail: {
        get () {
            return this.user.email
        },

        set (value) {
            this.setProperty({ property: 'stages2', value })
        }
    }

  },

  methods: mapActions('user', ['setProperty'])
}
